// extracted by mini-css-extract-plugin
export default {"btn":"LightBtn_btn__DEH4D","head":"LightBtn_head__E0HXx","btn1":"LightBtn_btn1__omHny","head1":"LightBtn_head1__LItVD"};